import script from "./UrlType.vue?vue&type=script&lang=js"
export * from "./UrlType.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__